// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-missions .callout-mission{position:relative}.step-missions .controls{position:absolute;top:0.5rem;right:0.5rem}.step-missions .controls .btn{margin-left:0.5rem}.step-missions .example{background-color:#e0edff;margin:0 10%;padding:5px;line-height:1.5em;text-align:left;display:block;font-style:italic}@media (max-width: 767.98px){.missions-header{flex-direction:column}}@media (max-width: 767.98px){.default-layout .btn.btn-round.btn-sm{max-width:30px}}\n", ""]);
// Exports
module.exports = exports;
